import { UntypedFormArray, UntypedFormControl } from '@angular/forms';

export const IsControlDisabled: (control: UntypedFormControl | UntypedFormArray) => boolean = (
    control: UntypedFormControl | UntypedFormArray
): boolean => {
    return control && control.disabled;
};
